<template>
  <div class="" style="font-size:15px" v-if="select">
    <span class="text-white bolder"> 훈련 선택 : </span>
    <select  v-model="select.year" class="mr-2  select-underline" @change="onSelectYear">
      <option :value="undefined" class="bolder">년도 선택</option>
      <option v-for="(year, i) in startYears" :key="i" :value="year">
        {{year}}
      </option>
    </select>
    <select  v-model="select.training" class="mr-2  select-underline" @change="onSelectTraining">
      <option :value="undefined"  class="bolder">훈련 선택</option>
      <option v-for="(training, i) in selTrainings" :key="i" :value="training">
        {{training.name}}
      </option>
    </select>
  </div>
</template>
<script>
import { } from 'mdbvue';
import Training from '@/models/Training'
import { mapActions, mapMutations, mapState } from 'vuex';
export default {
  name: 'ManagerTrainingSelect',
  components: { },
  props: [],
  data: () => ({
    trainings: {}
  }),
  computed: {
    ...mapState('auth', ['org']),
    ...mapState('training', ['select']),
    startYears () {
      return this.trainings && Object.keys(this.trainings).sort().reverse()
    },
    selTrainings () {
      return this.trainings && this.trainings[this.select.year]
    }
  },
  methods: {
    ...mapMutations('training', ['setTraining', 'setSelect', 'setSubjects']),
    ...mapActions('training', ['getSubjects']),
    async onSelectTraining () {
      if (this.select.training && this.select.training._id) {
        this.$emit('input', this.training)
        this.setSelect(this.select)
        this.setTraining(this.select.training)
        this.getSubjects(this.select.training._id)
      }
    },
    onSelectYear () {
      this.setTraining({})
      this.setSubjects({})
      this.select.training = {}
    },
    async load () {
      if (this.org && this.org._id) {
        this.trainings = await Training.get({ org: this.org._id })
        if (this.trainings) {
          this.trainings = this.trainings[this.org.name]
        }
      }
    }
  },
  async created () { this.load() },
  watch: { org () { this.load() } }
}
</script>
